import ErrorsTable from "..\\..\\..\\..\\src\\components\\error-codes.jsx";
import * as React from 'react';
export default {
  ErrorsTable,
  React
};